"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const actions_1 = require("./actions");
const react_redux_1 = require("react-redux");
const core_1 = require("@web3-react/core");
const hooks_1 = __importDefault(require("./hooks"));
const hooks_2 = require("../multicall/hooks");
function Updater() {
    const { library, chainId, account } = (0, core_1.useWeb3React)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const windowVisible = (0, hooks_1.default)();
    const [state, setState] = (0, react_1.useState)({
        chainId,
        blockNumber: null,
    });
    const blockNumberCallback = (0, react_1.useCallback)((blockNumber) => {
        setState((state) => {
            if (chainId === state.chainId) {
                if (typeof state.blockNumber !== "number")
                    return { chainId, blockNumber };
                return {
                    chainId,
                    blockNumber: Math.max(blockNumber, state.blockNumber),
                };
            }
            return state;
        });
    }, [chainId, setState]);
    (0, react_1.useEffect)(() => {
        dispatch((0, actions_1.setAccount)({ account: account !== null && account !== void 0 ? account : "" }));
    }, [account, dispatch]);
    // attach/detach listeners
    (0, react_1.useEffect)(() => {
        if (!library || !chainId || !windowVisible)
            return undefined;
        setState({ chainId, blockNumber: null });
        library
            .getBlockNumber()
            .then(blockNumberCallback)
            .catch((error) => console.error(`Failed to get block number for chainId: ${chainId}`, error));
        library.on("block", blockNumberCallback);
        return () => {
            library.removeListener("block", blockNumberCallback);
        };
    }, [dispatch, chainId, library, blockNumberCallback, windowVisible]);
    const debouncedState = (0, hooks_2.useDebounce)(state, 100);
    (0, react_1.useEffect)(() => {
        if (!debouncedState.chainId || !debouncedState.blockNumber || !windowVisible)
            return;
        dispatch((0, actions_1.updateBlockNumber)({
            chainId: debouncedState.chainId,
            blockNumber: debouncedState.blockNumber,
        }));
    }, [windowVisible, dispatch, debouncedState.blockNumber, debouncedState.chainId]);
    return null;
}
exports.default = Updater;
